import React from "react";
import Typewriter from "typewriter-effect";

function Type() {
  return (
    <Typewriter
      options={{
        strings: [
          "Made in Sweden",
          "Like kahoot but fun",
          "Ok kahoot is pretty fun",
          "Shoot asteroids!",
          "Inspired by peak panic",
        ],
        autoStart: true,
        loop: true,
        deleteSpeed: 50,
      }}
    />
  );
}

export default Type;
